import { render } from "./creation.vue?vue&type=template&id=6b45d6c2"
import script from "./creation.vue?vue&type=script&lang=js"
export * from "./creation.vue?vue&type=script&lang=js"

import "./creation.vue?vue&type=style&index=0&id=6b45d6c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__